<div class="login">

  <div class="login-form-holder">

    <div class="ava-iconbox">

      <div class="commentbox">
        <div class="comment">Dont worry! Resetting your password is easy. I will send a link to your email on file to
        get you signed back in!</div>
      </div>

      <div style="width: 300px;">
        <img src="/assets/images/ava.png"/>
      </div>

    </div>

    <form class="login-form">

      <div class="login-logo2">
        <img src="assets/images/DentmaLogo_white.png" width="100%" />
      </div>

      <div class="heading">Forgot password?</div>
      <div class="txt">Please enter your registered email address.</div>

      <div class="control-container">
        <mat-form-field>
          <div class="textbox-holder">
            <span class="fntxt">Email: </span>
            <input type="email" matInput [formControl]="username" class="input-textbox fninput" required
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" autocomplete="off">
            </div>
            @if (username.touched && username.errors) {
              <div class="validation-error">{{getUsernameMessage()}}</div>
            }
            @if (username.valid) {
              <div class="validation-error">{{error_msg}}</div>
            }
          </mat-form-field>

        </div>
        <button mat-stroked-button color="primary" (click)="sendResetLink()" class="sendlinkbtn">Send reset
        link</button>

        <a class="password" (click)="backToLogin()">Wait, I remembered my password!</a>
      </form>

    </div>
  </div>
